import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'

import { Container } from 'components'
import PaymentFooter from '../../components/PaymentFooter'

import CheckoutPlansRouter from '../../routers/CheckoutPlansRouter'

class CheckoutPlans extends Component {
  state = { firstName: 'Felipe' }

  render() {
    return (
      <Fragment>
        <Container>
          <CheckoutPlansRouter />
          <PaymentFooter isPartner />
        </Container>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    isAuth: state.auth.isAuth,
    userData: state.auth.userData,
  }
}

export default connect(mapStateToProps)(CheckoutPlans)